"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _bindTag = _interopRequireDefault(require("../lists/bindTag.vue"));
var _logDetail = _interopRequireDefault(require("./logDetail.vue"));
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'thirdOrderDetail',
  components: {
    BindTag: _bindTag.default,
    LogDetail: _logDetail.default
  },
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      orderDatalist: {},
      loading: false,
      baseOption: [
      // 订单基础信息
      {
        title: '订单编号',
        dataIndex: 'orderNo'
      }, {
        title: '订单状态',
        dataIndex: 'myStatus'
      }, {
        title: '三方订单状态',
        dataIndex: 'tstatus'
      }, {
        title: '产品名称',
        dataIndex: 'productName'
      }, {
        title: '配送方式',
        dataIndex: 'deliveryType'
      }, {
        title: '门店名称',
        dataIndex: 'storeName'
      }, {
        title: '门店电话',
        dataIndex: 'storePhone'
      }, {
        title: '配送时间',
        dataIndex: 'deliveryTime'
      }, {
        title: '备注',
        dataIndex: 'userRemark'
      }, {
        title: '地址',
        dataIndex: 'userAddress'
      }, {
        title: '订单金额',
        dataIndex: 'price'
      }, {
        title: '供应商扣费',
        dataIndex: 'supplyPrice'
      }],
      orderNo: null,
      needRefreshList: 0,
      // 关闭时是否需要刷新列表 0:不需要 1:需要
      neewRefresh: false
    };
  },
  mounted: function mounted() {},
  methods: {
    transformState: _transformState.default,
    openDetail: function openDetail(orderNo) {
      this.neewRefresh = false;
      this.orderNo = orderNo;
      if (!orderNo) {
        this.$message.warning('未查询到该订单！');
        return;
      }
      this.getOrderData();
    },
    getOrderData: function getOrderData() {
      var _this = this;
      this.dialogVisible = true;
      this.loading = true;
      dangaoActApi.getCakeOrderDetail({
        id: this.orderNo
      }).then(function (res) {
        _this.orderDatalist = res || {};
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    // 关闭弹窗，判断是否需要刷新列表
    handleColse: function handleColse() {
      this.dialogVisible = false;
      this.neewRefresh && this.$emit('doRefresh');
    },
    // 查看日志详情
    openReqDetail: function openReqDetail(row) {
      this.$refs['LogDetailRef'].openInit(row);
    },
    asynState: function asynState() {
      var _this2 = this;
      dangaoActApi.syncOrderState({
        id: this.orderNo
      }).then(function (res) {
        _this2.$message.success('操作成功！');
        _this2.neewRefresh = true;
      });
    }
  }
};